import Modal from '../scripts/modal'
import merge from 'lodash.merge';

class AddGroupModal {

  constructor (settings = {}) {

    this.settings = merge({
      onClose: null,
      onSuccess: null,
    }, settings);

    this.modal = new Modal({
      title: 'Create Group',
      onClose: this.settings.onClose,
    });

    this.modal.setContent(`
    <form class="create-group-form create-contact">

      <div class="create-group-form__content">

        <div class="setting">
          <div class="setting__label">Name</div>
          <input type="text" name="group_name" placeholder="Sensor group name" required />
          <p class="form-modal__description">A group or category for sensors such as "Freezer" or "Server Room"</p>
        </div>

      </div>

      <div class="setting-save">
        <div class="setting-save__button">
          <button type="submit" class="button button--blue">Create Group</button>
        </div>
        <div class="setting-save__message"></div>
      </div>

    </form>
    `);

    this.form = this.modal.getContainer().querySelector('form');

  }

  init() {

    this.modal.open();

    $(this.form).on("submit", async e => {

      e.preventDefault();

      const data = $(this.form).serialize();

      const result = await apiRequest('post', '/groups/create', data);

      console.log("create group", result);

      if(this.settings.onSuccess && result.type === 'success') {
        this.settings.onSuccess(result.data);
      }

      this.modal.close();

    })

  }

}

export default AddGroupModal;
